<template>
  <div class="detail-list">
    <div v-for="(item, index) in table" :key="`m-${index}`" class="list-item">
      <span class="list-item-name">{{ getTitle(item, index) }}</span>
      <span class="list-item-desc">{{ item.remark }}</span>
    </div>
  </div>
</template>

<script>
// 字典
import {
  otherMaterialRequirementDict,
  otherMaterialTypeDict
} from '@/dictionary/project/common'

/**
 * @Description: 其他材料要求展示列表
 */
export default {
  name: 'DetailList',

  props: {
    table: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {}
  },

  methods: {
    /**
     * 获取材料显示的标题
     */
    getTitle(item, index) {
      // 翻译是否必填的label
      const requiredEntry = otherMaterialRequirementDict.translate(
        item.isRequired
      )?.label

      // 翻译材料类型的label
      const typeEntry = otherMaterialTypeDict.translate(item.materialType)
        ?.label
      return `${index + 1}. ${
        item.materialName
      }（${requiredEntry}/${typeEntry}）`
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-list {
  .list-item {
    margin-right: 20px;

    & + .list-item {
      margin-top: 16px;
    }

    .list-item-name {
      color: $text-color;
    }

    .list-item-desc {
      color: $fourth-text-color;
    }
  }
}
</style>
